'use client'
import * as React from 'react'
import classes from './styles.module.css'
import Image from 'next/image'
import playImg from 'assets/icons/home-page/play.svg'
import VideoModal from './VideoModal'
import {useRouter, useSearchParams} from 'next/navigation'

export default function ProductVideo() {
  const [isOpen, setOpen] = React.useState(false)
  const router = useRouter()
  const searchParams = useSearchParams()

  React.useEffect(() => {
    const showVideo = searchParams.get('show-video')
    if (showVideo) {
      setOpen(true)
    }
  }, [])
  return (
    <div className={classes.container}>
      <div className={classes.subContainer}>
        <div className={classes.navBarBlurBg}></div>
        <div className={classes.header}>
          {' '}
          Manage <span style={{color: '#6B8CFF'}}>employees, identities, devices & apps </span>in
          one place
        </div>
        <div
          className={classes.play}
          onClick={() => {
            setOpen(true)
            router.push('?show-video=true')
          }}
        >
          Watch product overview
          <Image src={playImg} alt="play" className={classes.playIcon} />
        </div>
      </div>
      <div style={{zIndex: '20000'}}>
        {isOpen && (
          <VideoModal
            isOpen={isOpen}
            setOpen={(val: boolean | ((prevState: boolean) => boolean)) => {
              setOpen(val)
              router.push('/')
            }}
          />
        )}
      </div>
    </div>
  )
}
